import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=5e07b196&scoped=true&"
import script from "./MyAccount.vue?vue&type=script&lang=js&"
export * from "./MyAccount.vue?vue&type=script&lang=js&"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=5e07b196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e07b196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e07b196')) {
      api.createRecord('5e07b196', component.options)
    } else {
      api.reload('5e07b196', component.options)
    }
    module.hot.accept("./MyAccount.vue?vue&type=template&id=5e07b196&scoped=true&", function () {
      api.rerender('5e07b196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/MyAccount.vue"
export default component.exports